// StatusBadge：5 状态色的唯一对外入口。
// 业务代码禁止直接写 text-emerald / bg-red 等颜色 utility，必须用 variant。
// prefix 字符提供色盲 fallback：✓ ⚠ ✕ ⤴ ·

import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export type StatusVariant = "ok" | "warn" | "danger" | "drift" | "neutral";

interface StatusBadgeProps {
  variant: StatusVariant;
  children?: ReactNode;
  className?: string;
}

const PREFIX: Record<StatusVariant, string> = {
  ok: "✓",
  warn: "⚠",
  danger: "✕",
  drift: "⤴",
  neutral: "·",
};

const LABEL: Record<StatusVariant, string> = {
  ok: "正常",
  warn: "注意",
  danger: "失败",
  drift: "偏差",
  neutral: "未知",
};

export function StatusBadge({ variant, children, className }: StatusBadgeProps) {
  return (
    <span
      role="status"
      aria-label={typeof children === "string" ? children : LABEL[variant]}
      data-variant={variant}
      className={cn(
        "inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs font-medium leading-none",
        className,
      )}
      style={{
        color: `hsl(var(--${variant}))`,
        backgroundColor: `hsl(var(--${variant}-bg))`,
      }}
    >
      <span aria-hidden="true" className="font-mono">
        {PREFIX[variant]}
      </span>
      <span>{children ?? LABEL[variant]}</span>
    </span>
  );
}
